/**
 * undercover® — gedrag van globale onderdelen.
 * - snelle "erbij"-knoppen in de cart drawer ([data-uc-quick-add])
 * - confetti als gratis verzending bereikt wordt (.uc-ship[data-reached])
 * - nieuwsbrief-popup (<uc-popup>): exit-intent op desktop, na X s of Y% scroll op mobiel, max. 1× per N dagen
 * - footer: land/valuta-kiezer en de link "Cookievoorkeuren"
 */
(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(key) {
      try { return window.localStorage.getItem(key); } catch { return null; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, value); } catch { /* privémodus */ }
    },
  };

  /* Snel toevoegen vanuit de drawer */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-uc-quick-add]');
    if (!button || !window.ucCart) return;
    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    try {
      await window.ucCart.add([{ id: button.dataset.ucQuickAdd, quantity: 1 }], { source: 'cart-upsell', origin: button });
      window.ucTrack?.('cart_upsell_added', { variant: button.dataset.ucQuickAdd });
    } catch {
      /* toast wordt al door ucCart getoond */
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  /* Confetti bij het bereiken van gratis verzending */
  const colors = ['#3F5A3C', '#A8693A', '#D9C2A0', '#C9D3BF', '#6B4A33'];
  let lastReached = null;

  const burst = (host) => {
    if (reduceMotion() || host.dataset.confetti === 'false') return;
    for (let i = 0; i < 18; i++) {
      const dot = document.createElement('span');
      const angle = (Math.PI * 2 * i) / 18 + Math.random() * 0.4;
      const distance = 50 + Math.random() * 70;
      dot.className = 'uc-confetti';
      dot.style.setProperty('--c', colors[i % colors.length]);
      dot.style.setProperty('--dx', `${Math.cos(angle) * distance}px`);
      dot.style.setProperty('--dy', `${Math.sin(angle) * distance * 0.7 - 20}px`);
      dot.style.setProperty('--r', `${Math.random() * 540 - 270}deg`);
      host.append(dot);
      setTimeout(() => dot.remove(), 1000);
    }
  };

  const checkShipping = () => {
    const bar = document.querySelector('.uc-ship[data-free-here="true"]');
    if (!bar) return;
    const reached = bar.dataset.reached === 'true';
    if (lastReached === false && reached) burst(bar);
    lastReached = reached;
  };

  new MutationObserver(checkShipping).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-reached'],
  });
  checkShipping();

  /* Nieuwsbrief-popup */
  /* Bezoekers uit een advertentie (utm_source) en wie iets in de winkelwagen legt: geen popup meer deze sessie */
  const buyerFlag = 'uc_popup_skip';
  try {
    if (new URLSearchParams(location.search).has('utm_source')) sessionStorage.setItem(buyerFlag, '1');
  } catch { /* privémodus */ }
  document.addEventListener('cart:update', () => {
    try { sessionStorage.setItem(buyerFlag, '1'); } catch { /* */ }
  });

  class UcPopup extends HTMLElement {
    isBuyer() {
      if (['product', 'cart'].includes(this.dataset.template)) return true;
      if (Number(this.dataset.cartCount || 0) > 0) return true;
      try { return sessionStorage.getItem(buyerFlag) === '1'; } catch { return false; }
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      const key = 'uc_popup_seen';
      const days = Number(this.dataset.days || 7);
      const seen = Number(store.get(key) || 0);
      const inEditor = window.Shopify?.designMode;

      this.querySelectorAll('[data-uc-popup-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      this.dialog.addEventListener('close', () => store.set(key, String(Date.now())));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      const flag = 'uc_popup_submitted';
      this.querySelector('#UcPopupForm')?.addEventListener('submit', () => {
        try { sessionStorage.setItem(flag, '1'); } catch { /* */ }
      });
      let submittedHere = false;
      try { submittedHere = sessionStorage.getItem(flag) === '1'; sessionStorage.removeItem(flag); } catch { /* */ }

      // Aangemeld via déze popup: bedankje tonen
      if (submittedHere && this.querySelector('[data-uc-popup-success]')) {
        window.ucTrack?.('popup_signup', { source: 'popup' });
        store.set(key, String(Date.now() + 1000 * 60 * 60 * 24 * 365));
        this.open();
        return;
      }

      if (inEditor || this.dataset.enabled !== 'true') return;
      if (seen && Date.now() - seen < days * 864e5) return;
      if (this.dataset.skipBuyers === 'true' && this.isBuyer()) return;

      const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
      if (desktop) {
        const onLeave = (event) => {
          if (event.clientY <= 0) {
            document.removeEventListener('mouseout', onLeave);
            if (!(this.dataset.skipBuyers === 'true' && this.isBuyer())) this.open();
          }
        };
        document.addEventListener('mouseout', onLeave);
      } else {
        const delay = Number(this.dataset.delay || 30) * 1000;
        const ratio = Number(this.dataset.scroll || 50) / 100;
        const timer = setTimeout(() => { if (!(this.dataset.skipBuyers === 'true' && this.isBuyer())) this.open(); }, delay);
        const scroller = document.scrollingElement;
        const onScroll = () => {
          const max = scroller.scrollHeight - window.innerHeight;
          if (max > 0 && scroller.scrollTop / max >= ratio) {
            window.removeEventListener('scroll', onScroll);
            clearTimeout(timer);
            if (!(this.dataset.skipBuyers === 'true' && this.isBuyer())) this.open();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    open() {
      if (this.dialog.open || document.querySelector('dialog[open]:not(.uc-popup)')) return;
      this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }
  }

  if (!customElements.get('uc-popup')) customElements.define('uc-popup', UcPopup);

  /* Footer: land/valuta direct wisselen en de cookiebanner van Shopify opnieuw openen */
  document.addEventListener('change', (event) => {
    if (event.target.matches('select[data-uc-autosubmit]')) event.target.form?.requestSubmit();
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-uc-cookie-preferences]');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  /* Editor: popup tonen als het blok/de sectie geselecteerd wordt */
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelector('uc-popup')?.open();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    event.target.querySelector('uc-popup')?.close();
  });
})();
